import { styled } from '@mui/material';
export const PreLineBox = styled('div')({
    whiteSpace: 'pre-line',
});
